const RETRY_INTERVAL = 50;
const MAX_RETRIES = 40;

// 目标区块可能位于尚未加载完成的懒加载页面中，因此需要重试查找。
export const scrollToSection = (id: string) => {
  let retries = 0;

  const tryScroll = () => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    if (retries < MAX_RETRIES) {
      retries += 1;
      window.setTimeout(tryScroll, RETRY_INTERVAL);
    }
  };

  tryScroll();
};
